<template>
  <div>
    <div class="space-y-8">
      <div class="space-y-2">
        <div class="text-lg font-semibold text-gray-900">
          Datos de la factura de América asociada
        </div>
        <div class="flex flex-wrap gap-y-1 tracking-wide text-gray-700">
          <div class="space-x-2 after:px-2 after:font-thin after:content-['\2022']">
            <span class="font-semibold">Tipo de factura</span>
            <span>{{ comprobanteTerceros.uso.factura_codigo.toUpperCase() }}</span>
          </div>
          <div class="space-x-2">
            <span class="font-semibold">Número de factura</span>
            <span>{{ comprobanteTerceros.uso.factura_numero }}</span>
          </div>
        </div>
        <ComprobantesFactura
          :facturaCodigo="comprobanteTerceros.uso.factura_codigo"
          :facturaNumero="comprobanteTerceros.uso.factura_numero"
          :sede="comprobanteTerceros.sede"
        />
      </div>
      <MessageCard
        v-if="!comprobantePago"
        type="info"
        message="El pago del comprobante no ha sido informado."
      />
      <div v-if="sede.id.trim() == comprobanteTerceros.sede.id.trim()" class="space-y-4">
        <div class="space-y-2 md:flex md:items-center md:space-x-6 md:space-y-0">
          <label for="observaciones" class="w-44 text-sm font-medium tracking-wide text-gray-700">
            <span>Observaciones</span>
          </label>
          <div class="w-full max-w-xl sm:w-5/6">
            <textarea
              v-model="observaciones"
              id="observaciones"
              maxlength="255"
              class="block w-full rounded-md shadow-sm transition duration-200 ease-in-out sm:text-sm"
            />
          </div>
        </div>
        <div class="flex justify-center">
          <button
            class="inline-flex items-center space-x-2 rounded-md bg-colescba-blue-500 px-5 py-2 text-sm font-medium uppercase tracking-wide text-white transition duration-150 ease-in-out hover:bg-colescba-blue-600 focus:outline-none focus:ring-1 focus:ring-colescba-blue-500 focus:ring-offset-1"
            @click="showConfirmModal = true"
            type="button"
          >
            Anular uso de comprobante
          </button>
        </div>
      </div>
      <div v-else class="font-medium text-red-500">
        El comprobante no pertenece a su delegación.
      </div>
    </div>
    <ConfirmationModal
      :isOpen="showConfirmModal"
      @save="anularComprobante"
      @modal:cancel="showConfirmModal = false"
    >
      <span v-if="comprobante">
        Se anulará el uso del comprobante {{ comprobante.numero_comprobante }}.
      </span>
    </ConfirmationModal>
  </div>
</template>

<script>
import { useSession } from '@colescba/ui'
import { useService } from '@colescba/app-vue'

import { mapGetters } from 'vuex'
import ConfirmationModal from '@/components/Core/ConfirmationModal'
import MessageCard from '@/components/Core/MessageCard'
import ComprobantesFactura from './ComprobantesFactura'

export default {
  components: { ConfirmationModal, MessageCard, ComprobantesFactura },

  mixins: [useService('portalPagos'), useSession()],

  props: {
    comprobanteTerceros: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      showConfirmModal: false,
      observaciones: null,
    }
  },

  computed: {
    ...mapGetters({
      sede: 'app/sedeCajero',
    }),
    comprobante() {
      return this.comprobanteTerceros?.comprobante
    },
    comprobantePago() {
      return this.comprobanteTerceros?.pago.estado_id == 'PAGO'
    },
  },

  methods: {
    async anularComprobante(done) {
      try {
        await this.portalPagos.patchUsoComprobante(
          this.user.cuitCuil.numero,
          this.comprobante.numero_comprobante,
          {
            uso_id: 'USO_ANULADO',
            observaciones: this.observaciones,
          }
        )

        done()
        this.$emit('reload')

        this.$toast.open({
          message: 'El uso del comprobante fue anulado correctamente.',
          type: 'success',
          duration: 2500,
          dismissible: true,
        })
      } catch (e) {
        console.log(e)
        done('Ocurrió un error al procesar la información.')
      }
    },
  },
}
</script>
